var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-main-2xl main-text-color flex items-center font-medium truncate",style:(_vm.getStyles)},[_vm._v("\n    "+_vm._s(_vm.getDateInterval)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }